<template>
  <div class="bk-main-canvas">
    <ClientOnly>
      <div v-if="showToolbar" class="toolbar-wrapper">
        <VuepalAdminToolbar key="language" />
        <div class="is-flex">
          <div class="toolbar-inner">
            <VuepalLocalTasks />
          </div>
        </div>
      </div>
    </ClientOnly>
    <NuxtLoadingIndicator color="#FDC861" />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
const route = useRoute()
const drupalUser = useDrupalUser()

const isEditing = computed(
  () =>
    !!(route.query.blokkliEditing || route.query.blokkliPreview) &&
    drupalUser.value.accessToolbar,
)

const showToolbar = computed(() => {
  return drupalUser.value.accessToolbar && !isEditing.value
})

useHead({
  htmlAttrs: {
    lang: 'de',
    class: computed(() => {
      if (showToolbar.value) return 'vuepal-toolbar'
      return ''
    }),
  },
  bodyAttrs: {
    class: computed(() => {
      if (showToolbar.value) return 'vuepal-toolbar'
      return ''
    }),
  },
})
</script>

<style lang="postcss">
html.has-navbar-fixed-top.vuepal-toolbar,
body.has-navbar-fixed-top.vuepal-toolbar {
  @media (min-width: 1024px) {
    margin-top: 130px;
  }
}

.vuepal-toolbar nav.navbar.main-nav {
  @media (min-width: 1024px) {
    margin-top: 130px;
  }
}

.toolbar-wrapper {
  display: none;
  top: 0;
  left: 0;
  position: fixed;
  right: 0;
  z-index: 100;
  height: 130px;
  background-color: #fff;
}

@media (min-width: 1024px) {
  .toolbar-wrapper {
    display: block;
  }
}

.toolbar-inner {
  margin-left: auto;
  margin-right: auto;
  width: auto;
  height: 70px;
  padding-top: 1rem;
}
</style>
